import { PHASE_COLORS, cn } from '../../lib/utils';

/** Course phase bar: 7 segments proportional to count per phase. counts[0] = phase 1. */
export function PhaseBar({
  counts,
  className,
  height = 12,
  delay = 0,
}: {
  counts: number[];
  className?: string;
  height?: number;
  delay?: number;
}) {
  const total = counts.reduce((a, b) => a + b, 0);
  return (
    <div
      className={cn('overflow-hidden rounded-[7px] border-2 border-ink bg-track', className)}
      style={{ height }}
      role="img"
      aria-label={`Phasenverteilung: ${counts.join(', ')}`}
    >
      <div
        className="flex h-full origin-left animate-grow"
        style={{ animationDelay: `${delay}ms` }}
      >
        {total > 0 &&
          counts.map((c, i) =>
            c > 0 ? (
              <div
                key={i}
                style={{
                  width: `${(c / total) * 100}%`,
                  background: PHASE_COLORS[i],
                  borderLeft: i > 0 ? '1px solid rgba(22,21,18,.25)' : undefined,
                }}
              />
            ) : null
          )}
      </div>
    </div>
  );
}

/** 7 dots; the first `phase` filled with that phase's color. */
export function PhaseDots({
  phase,
  size = 8,
  lostAt,
  gainedAt,
  popGained,
  className,
}: {
  phase: number;
  size?: number;
  /** phase index (1-7) shown red as lost dot */
  lostAt?: number;
  /** phase index (1-7) shown in marker color (newly gained) */
  gainedAt?: number;
  popGained?: boolean;
  className?: string;
}) {
  return (
    <div className={cn('flex items-center gap-[3px]', className)} aria-label={`Phase ${phase} von 7`}>
      {Array.from({ length: 7 }, (_, i) => {
        const n = i + 1;
        const filled = n <= phase;
        let bg = 'transparent';
        if (filled) bg = PHASE_COLORS[phase - 1];
        if (gainedAt === n) bg = '#F4D03F';
        if (lostAt === n) bg = '#EF6B57';
        return (
          <span
            key={n}
            className={cn('inline-block rounded-full border-[1.5px] border-ink', gainedAt === n && popGained && 'animate-pop')}
            style={{ width: size, height: size, background: bg }}
          />
        );
      })}
    </div>
  );
}
